import { render, staticRenderFns } from "./wetin.vue?vue&type=template&id=83621870&scoped=true&"
import script from "./wetin.vue?vue&type=script&lang=js&"
export * from "./wetin.vue?vue&type=script&lang=js&"
import style0 from "./wetin.vue?vue&type=style&index=0&id=83621870&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83621870",
  null
  
)

export default component.exports